export const highlightTypes = {
    highlight: "Destacado",
    discount: "Descuento",
    common: "Común"
};
